/*@flow*/
import type { Element } from 'react'; /** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { useContext } from 'react';
import BuilderContext from '../Context';
import humanize from 'underscore.string/humanize';

type PropsT = { isLoading: boolean, submitForm: Function };

const Component = (props: PropsT): Element<string> => {
  const ctx = useContext(BuilderContext);
  const { resource, resourceName } = ctx.state;
  const id = resource.get('id');
  const btnPrompt = id ? 'Update' : 'Create';
  let btnText;
  if (props.isLoading) {
    btnText = 'Loading...';
  } else {
    btnText = `${btnPrompt} ${humanize(resourceName)}`;
  }
  return (
    <div
      className="btn-group action-btn-group"
      css={css(`
        position: sticky;
        left: 0;
        bottom: 0px;
        width: 100%;
        margin: 0;
        z-index: 99;
      `)}
    >
      <a
        className="btn btn-lg btn-primary btn-block action-btn"
        data-testid="ActionBtn"
        onClick={(e) => (props.isLoading ? null : props.submitForm(e))}
        disabled={props.isLoading}
        tabIndex={0}
      >
        {btnText}
      </a>
    </div>
  );
};
export default Component;
